var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pa-5", attrs: { "data-qa": "common_price_details" } },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-space-between text-h6 text--text" },
        [
          _vm._v("\n    Обычная цена\n    "),
          _c(
            "span",
            { attrs: { "data-qa": "common_price_details_lpu_price" } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.getFormattedPrice(_vm.fullPrice)) +
                  "\n    "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-1 text-secondary--text mt-2" }, [
        _vm._v("\n    Оплата в клинике\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }